// src/data/exercises/L6_03.js

const accountOptions = [
  '現金', '給料', '所得税預り金', '当座預金', '普通預金'];

export const L6_03 = {
  title: '簿記　3級（第215-3回）',
  questions: [
    {
      id: 'q1',
      type: 'JOURNAL_ENTRY',
        content: {

    parts: [
    { "type": "ruby", "text": "福井株式会社", "ruby": "ふくいかぶしきがいしゃ" },
    { "type": "text", "value": "は、" },
    { "type": "ruby", "text": "従業員", "ruby": "じゅうぎょういん" },
    { "type": "text", "value": "への" },
    { "type": "ruby", "text": "給料", "ruby": "きゅうりょう" },
    { "type": "text", "value": "￥5,000,000の" },
    { "type": "ruby", "text": "支払", "ruby": "しはらい" },
    { "type": "text", "value": "いに" },
    { "type": "ruby", "text": "際", "ruby": "さい" },
    { "type": "text", "value": "して、" },
    { "type": "ruby", "text": "所得税", "ruby": "しょとくぜい" },
    { "type": "text", "value": "の" },
    { "type": "ruby", "text": "源泉徴収額", "ruby": "げんせんちょうしゅうがく" },
    { "type": "text", "value": "￥510,500を" },
    { "type": "ruby", "text": "差", "ruby": "さ" },
    { "type": "text", "value": "し" },
    { "type": "ruby", "text": "引", "ruby": "ひ" },
    { "type": "text", "value": "き、" },
    { "type": "ruby", "text": "普通預金口座", "ruby": "ふつうよきんこうざ" },
    { "type": "text", "value": "から" },
    { "type": "ruby", "text": "口座振替", "ruby": "こうざふりかえ" },
    { "type": "text", "value": "で" },
    { "type": "ruby", "text": "支払", "ruby": "しはら" },
    { "type": "text", "value": "った。" }
]

      },
      table: {
        options: accountOptions,
      },
      // Đáp án có 1 dòng Nợ và 2 dòng Có
      answer: [
        { debitAccount: '給料', debitAmount: 5000000, creditAccount: '所得税預り金', creditAmount: 510500 },
        { debitAccount: null, debitAmount: null, creditAccount: '普通預金', creditAmount: 4489500 },
              ],
       // Giải thích chi tiết khi trả lời ĐÚNG (có định dạng)
      explanation_correct: {

        parts: [
          { type: 'text', value: '①「給料￥5,000,000の支払い」\n' },
          { type: 'styled', value: '→給料が借方（左・Ｄｒ）\n\n', color: 'red', bold: true },

          { type: 'text', value: '②「所得税の源泉徴収額￥510,500を差し引き」\n' },
          { type: 'styled', value: '→所得税預り金が貸方（右・Ｃｒ）\n\n', color: 'red', bold: true },
          
          { type: 'text', value: '③「普通預金口座から」\n' },
          { type: 'styled', value: '→普通預金の減少（マイナス）貸方（右・Ｃｒ）', color: 'red', bold: true },
          
        ]
      },

      // Gợi ý 2 cấp độ khi trả lời SAI
      hints: {
        account: [
          // Gợi ý lần 1, 2
`
①「給料￥5,000,000の支払い」
→給料が発生（プラス）します。

②「所得税の源泉徴収額￥510,500を差し引き」
　→所得税預り金が増加（プラス）します。

③「普通預金口座から」
→普通預金の減少（マイナス）します。

`,
          // Gợi ý lần 3 (chi tiết hơn, có định dạng)
          {

        parts: [
          { type: 'text', value: '①「給料￥5,000,000の支払い」\n' },
          { type: 'styled', value: '→給料が借方（左・Ｄｒ）\n\n', color: 'red', bold: true },

          { type: 'text', value: '②「所得税の源泉徴収額￥510,500を差し引き」\n' },
          { type: 'styled', value: '→所得税預り金が貸方（右・Ｃｒ）\n\n', color: 'red', bold: true },
          
          { type: 'text', value: '③「普通預金口座から」\n' },
          { type: 'styled', value: '→普通預金の減少（マイナス）貸方（右・Ｃｒ）', color: 'red', bold: true },
          
        ]

          }
        ],
       
      },
    },
  ],
};